// extracted by mini-css-extract-plugin
export default {"title_text":"style_title_text__e0zjY","normal":"style_normal__Qhl4b","large":"style_large__H0oiI","x-large":"style_x-large__+eMN7","description_text":"style_description_text__2v2J2"};